export const sessionEntryApi = {
    heading:[
        {
            head:"Session ID"
        },
        {
            head:"Session Name"
        },
        {
            head:"Start Date"
        },
        {
            head:"End Date"
        },
        {
            head:"Status"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
     
       
    ]
}